// OS 종류의 낱말. 관리자가 적는 자유 글자라 사전에 있는 것만 이름이 되고 나머지는 `기타` 로 묶인다 —
// 원문을 화면에 내지 않는다. VM 생성 페이지가 이미지를 이 낱말로 타일에 묶는다.
const OS_WORD: Record<string, string> = {
  ubuntu: 'Ubuntu',
  debian: 'Debian',
  rocky: 'Rocky Linux',
  almalinux: 'AlmaLinux',
  centos: 'CentOS',
  rhel: 'Red Hat',
  fedora: 'Fedora',
  windows: 'Windows',
}

/** 사전에 없거나 비운 OS 종류의 낱말. */
export const OS_OTHER = '기타'

/** 이미지가 말하는 OS 종류의 낱말. 대소문자와 앞뒤 공백은 가리지 않는다. */
export function osWord(family: string | null | undefined): string {
  return (family ? OS_WORD[family.trim().toLowerCase()] : undefined) ?? OS_OTHER
}

// OS 의 계열. 같은 계열은 패키지 관리자와 관리 방식을 나눈다 — VM 생성 페이지가 타일을 이 계열로 묶는다.
// 원본은 OS 종류이고, 사전에 없는 종류는 `기타` 다.
const OS_LINE: Record<string, string> = {
  ubuntu: 'Debian 계열',
  debian: 'Debian 계열',
  rocky: 'Red Hat 계열',
  almalinux: 'Red Hat 계열',
  centos: 'Red Hat 계열',
  rhel: 'Red Hat 계열',
  fedora: 'Red Hat 계열',
  windows: 'Windows',
}

/** 계열을 보이는 순서. */
export const OS_LINES = ['Debian 계열', 'Red Hat 계열', 'Windows', OS_OTHER] as const

/** 이미지가 말하는 OS 종류의 계열. */
export function osLine(family: string | null | undefined): string {
  return (family ? OS_LINE[family.trim().toLowerCase()] : undefined) ?? OS_OTHER
}
